import React, { memo, useEffect, useRef } from 'react';
import LazyLoad from 'react-lazyload';
import { configOkeReview } from '../../utils/helpers';

export const OkendoStarRating = memo(({ productId, hide = false }) => {
  const widgetContainer = useRef(null);

  const initialiseReviewsWidget = (loadReviewsWidget) => {
    const div = document.createElement('div');
    div.setAttribute('data-oke-star-rating', '');

    div.setAttribute('data-oke-reviews-product-id', `shopify-${productId}`);
    // div.setAttribute('data-oke-reviews-product-id', `shopify-8254388502692`);

    if (widgetContainer?.current) {
      if (hide) widgetContainer.current.style.display = 'none';
      widgetContainer.current.innerHTML = '';
      if (window?.okeWidgetApi) {
        window.okeWidgetApi.initWidget(div);
        widgetContainer.current.appendChild(div);
        clearInterval(loadReviewsWidget);
        if (hide) {
          let count = 0;
          const checkStarRating = setInterval(() => {
            if (div.getElementsByTagName('script').length) {
              const review = JSON.parse(div.getElementsByTagName('script')[0].innerText);
              if (review.reviewCount) {
                widgetContainer.current.style.display = 'block';
                clearInterval(checkStarRating);
              }
            }
            if (count >= 5) clearInterval(checkStarRating);
            count++;
          }, 500);
        }
      }
    }
  };

  useEffect(() => {
    configOkeReview();
    const loadReviewsWidget = setInterval(() => {
      if (window.okeWidgetApi) {
        initialiseReviewsWidget(loadReviewsWidget);
      }
      // else {
      //   window.addEventListener('oke-script-loaded', initialiseReviewsWidget());
      // }
    }, 500);
  }, [productId]);

  return <div ref={widgetContainer} />;
});

const OkendoStarSnippet = memo((props) => (
  // <LazyLoad throttle={500} height={100} scroll={true} one>
  <OkendoStarRating {...props} />
  // </LazyLoad>
));

export default OkendoStarSnippet;
